import axios from "axios";

const api = axios.create({
    baseURL: "https://goodcard-1566319852370.firebaseio.com/"
});

export default api;